import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import amount from "amount";

const Bar = props => {
  const [options, setOptions] = useState({});
  const [series, setSeries] = useState([]);

  useEffect(() => {
    if (!props || !props.categories) return;

    setOptions({
      dataLabels: {
        enabled: true,
        formatter: function(val, opt) {
          return "";
        },
        offsetX: 0,
        textAnchor: "start"
      },
      tooltip: {
        y: {
          formatter: function(value) {
            if (props.isAmount) {
              return amount.currency(value, "USD");
            }

            return value;
          }
        }
      },
      xaxis: {
        categories: props.categories
      },
      yaxis: {
        labels: {
          formatter: value => {
            if (props.isAmount) {
              return amount.currency(value, "USD");
            }

            return value;
          }
        }
      }
    });

    if (props.seriesMultiple) {
      setSeries(props.seriesMultiple);
    } else {
      setSeries([
        {
          data: props.series,
          name: ""
        }
      ]);
    }
  }, [props]);

  return <Chart options={options} series={series} type="bar" width="100%" />;
};

export default Bar;
